<template>
	<div class="mainClass">
		<br/>
		<b style="font-size: 25px;">欢迎使用分拣称重系统</b>
		<Row :gutter="16">
			<Col span="8">
				<div class="cardParent" @click="targetPage(1)">
					<div class="cardLeft">
						<Icon type="ios-stopwatch" size="60" style="margin-top: 10px;"/>
					</div>
					<div class="cardRight">
						<h1>计重商品分拣</h1>
					</div>
				</div>
			</Col>
			<Col span="8">
				<div class="cardParent" @click="targetPage(2)">
					<div class="cardLeft" style="background-color: #003D60">
						<Icon type="md-basket" size="60" style="margin-top: 10px;"/>
					</div>
					<div class="cardRight" style="background-color: #00437c">
						<h1>不计重商品分拣</h1>
					</div>
				</div>
			</Col>
			<!--<Col span="8">
				<div class="cardParent" @click="targetPage(3)">
					<div class="cardLeft" style="background-color: #996600">
						<Icon type="md-cart" size="60" style="margin-top: 10px;"/>
					</div>
					<div class="cardRight" style="background-color: #CC9966">
						<h1>商品检索分拣</h1>
					</div>
				</div>
			</Col>-->
			<Col v-if="$store.state.user.userInfo.platform!=CONSTANT.P_LOGIN_TYPE.ADMIN_SUPPLIER" span="8">
				<div class="cardParent" @click="targetPage(4)">
					<div class="cardLeft" style="background-color: #9F5000">
						<Icon type="md-list-box" size="60" style="margin-top: 10px;"/>
					</div>
					<div class="cardRight" style="background-color: #D26900">
						<h1>按客户分拣</h1>
					</div>
				</div>
			</Col>
			<Col v-if="showPreSorting" span="8">
				<div class="cardParent" @click="targetPage(8)">
					<div class="cardLeft" style="background-color: #613030">
						<Icon type="ios-cube" size="60" style="margin-top: 10px;"/>
					</div>
					<div class="cardRight" style="background-color: #804040">
						<h1>商品预分拣</h1>
					</div>
				</div>
			</Col>
			<Col span="8">
				<div class="cardParent" @click="targetPage(5)">
					<div class="cardLeft" style="background-color: #003E3E">
						<Icon type="md-checkbox" size="60" style="margin-top: 10px;"/>
					</div>
					<div class="cardRight" style="background-color: #005a3b">
						<h1>差异分拣</h1>
					</div>
				</div>
			</Col>
		</Row>
		<br/>
		<b style="font-size: 25px;">配置/设置相关</b>
		<Row :gutter="16">
			<Col span="8">
				<div class="cardParentTwo" @click="targetPage(6)">
					<Icon type="ios-filing" color="#005a3b" size="60"/>
					<p>称重筐管理</p>
				</div>
			</Col>
			<Col span="8">
				<div class="cardParentTwo" @click="targetPage(7)">
					<Icon type="ios-settings" color="#005a3b" size="60"/>
					<p>设置中心</p>
				</div>
			</Col>
		</Row>
	</div>
</template>

<script>
	const CONSTANT = require("../../../common/const");
	export default {
		name: 'home',
		data() {
			return {
				CONSTANT
			}
		},
		computed: {
			showPreSorting() {
				let canshow = false;
				if (this.$store.state.platform_setting && this.$store.state.platform_setting.miniModuleArr.includes("preSorting")) {
					canshow = true;
				}
				return canshow
			}
		},
		methods: {
			// 跳转页面
			targetPage(index) {
				if (index == 1) {
					// 计重商品分拣
					this.$router.push({name: "weightSorting",});
				}
				if (index == 2) {
					// 不计重商品分拣
					this.$router.push({name: "standardSorting",});
				}
				if (index == 3) {
					// 商品检索
					this.$Notice.info({title: "内测中，暂未开放",});
				}
				if (index == 4) {
					this.$router.push({name: "orderSorting",});
				}
				if (index == 5) {
					this.$router.push({name: "diffSorting",});
				}
				if (index == 6) {
					this.$router.push({name: "turnoverList",});
				}
				if (index == 7) {
					this.$router.push({name: "setting",});
				}
				if (index == 8) {
					this.$router.push({name: "preSorting",});
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.mainClass {
		padding: 10px 18px 18px 18px;
		box-sizing: border-box;
	}

	.cardParent {
		height: 150px;
		border-radius: 6px;
		overflow: hidden;
		margin-top: 20px;

		.cardLeft {
			width: 25%;
			background-color: #2a5caa;
			height: 150px;
			float: left;
			text-align: center;
			line-height: 170px;
			color: #F0F0F0
		}

		.cardRight {
			width: 75%;
			background-color: #4c70db;
			height: 150px;
			float: left;
			text-align: center;
			line-height: 150px;
			color: #F0F0F0
		}

	}

	.cardParentTwo {
		display: flex;
		height: 150px;
		margin-top: 20px;
		align-items: center;
		border-radius: 6px;
		flex-direction: column;
		justify-content: center;
		background-color: #FFFFFF;
		border: 1px solid #dedede;

		p {
			color: #333;
			font-size: 18px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/view/home/home.vue